export const uploadURL = "/sourcing/venues/manage-bucket/";
export const deleteURL = "/sourcing/venues/manage-bucket/";
